export const TYPES = {
    HIDE_PM_RECOMMENDATION_BANNER: 'HIDE_PM_RECOMMENDATION_BANNER',
    HIDE_BM_MAZE_BANNER: 'HIDE_BM_MAZE_BANNER',
    SHOW_BM_MAZE_BANNER: 'SHOW_BM_MAZE_BANNER',
    HIDE_BM_CP_BANNER: 'HIDE_BM_CP_BANNER',
    SHOW_BM_CP_BANNER: 'SHOW_BM_CP_BANNER',
    HIDE_BM_INTERVENTION_BANNER: 'HIDE_BM_INTERVENTION_BANNER',
    HIDE_BM_LNF_PSF_BANNER: 'HIDE_BM_LNF_PSF_BANNER',
    ENABLE_LNFPSF_BANNER: 'ENABLE_LNFPSF_BANNER',
    ENABLE_MAZE_BANNER: 'ENABLE_MAZE_BANNER',
    ENABLE_CP_BANNER: 'ENABLE_CP_BANNER',
    HIDE_FNL_BANNER: 'HIDE_FNL_BANNER',
    SHOW_FNL_BANNER: 'SHOW_FNL_BANNER',
    ENABLE_FNL_BANNER: 'ENABLE_FNL_BANNER',
    SHOW_SUMMER_BANNER: 'SHOW_SUMMER_BANNER',
    HIDE_SUMMER_BANNER: 'HIDE_SUMMER_BANNER',
    HIDE_PM_CP_BANNER: 'HIDE_PM_CP_BANNER',
    SHOW_PM_CP_BANNER: 'SHOW_PM_CP_BANNER',
    ENABLE_PM_CP_BANNER: 'ENABLE_PM_CP_BANNER',
};

export const hidePMRecommendationBanner = dispatch => payload => {
    dispatch({ type: TYPES.HIDE_PM_RECOMMENDATION_BANNER, payload });
};

export const hideBMMazeBanner = dispatch => payload => {
    dispatch({ type: TYPES.HIDE_BM_MAZE_BANNER, payload });
};

export const showBMMazeBanner = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_BM_MAZE_BANNER, payload });
};

export const hideBMCPBanner = dispatch => payload => {
    dispatch({ type: TYPES.HIDE_BM_CP_BANNER, payload });
};

export const showBMCPBanner = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_BM_CP_BANNER, payload });
};

export const hideBMInterventionBanner = dispatch => payload => {
    dispatch({ type: TYPES.HIDE_BM_INTERVENTION_BANNER, payload });
};

export const hideBMLNFPSFBanner = dispatch => payload => {
    dispatch({ type: TYPES.HIDE_BM_LNF_PSF_BANNER, payload });
};

export const showBMLNFPSFBanner = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_BM_LNF_PSF_BANNER, payload });
};

export const enableMazeBanner = dispatch => payload => {
    dispatch({ type: TYPES.ENABLE_MAZE_BANNER, payload });
};

export const enableCPBanner = dispatch => payload => {
    dispatch({ type: TYPES.ENABLE_CP_BANNER, payload });
};

export const enableLNFPSFBanner = dispatch => payload => {
    dispatch({ type: TYPES.ENABLE_LNFPSF_BANNER, payload });
};

export const hideFNLBanner = dispatch => payload => {
    dispatch({ type: TYPES.HIDE_FNL_BANNER, payload });
};

export const showFNLBanner = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_FNL_BANNER, payload });
};

export const enableFNLBanner = dispatch => payload => {
    dispatch({ type: TYPES.ENABLE_FNL_BANNER, payload });
};

export const showSummerBanner = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_SUMMER_BANNER, payload });
};

export const hideSummerBanner = dispatch => payload => {
    dispatch({ type: TYPES.HIDE_SUMMER_BANNER, payload });
};

export const hidePMCPBanner = dispatch => payload => {
    dispatch({ type: TYPES.HIDE_PM_CP_BANNER, payload });
};

export const showPMCPBanner = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_PM_CP_BANNER, payload });
};

export const enablePMCPBanner = dispatch => payload => {
    dispatch({ type: TYPES.ENABLE_PM_CP_BANNER, payload });
};
